/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format, convert, diff, and explore JSON entirely in your browser.
No uploads, no accounts, no tracking. Just fast and private tools.`)
};

const ko_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 안에서 JSON을 포맷, 변환, 비교, 탐색하세요.
업로드도 계정도 추적도 없이, 빠르고 안전한 도구만 제공합니다.`)
};

const ja_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザだけで JSON を整形、変換、比較、確認できます。
アップロードもアカウントも追跡もなし。速くて安全なツールだけです。`)
};

/**
* | output |
* | --- |
* | "Format, convert, diff, and explore JSON entirely in your browser. No uploads, no accounts, no tracking. Just fast and private tools." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_subtitle(inputs)
	if (locale === "ko") return ko_home_hero_subtitle(inputs)
	return ja_home_hero_subtitle(inputs)
});